import type { QuoteTemplate } from "@/types/quote";

export const templates: QuoteTemplate[] = [
	{
		id: "web-dev",
		name: "Web Development",
		description: "Website design and development projects",
		icon: "Globe",
		category: "service",
		accentColor: "#2563eb",
		defaultItems: [
			{ description: "Discovery & Requirements Gathering", quantity: 1, unitPrice: 1500, discount: 0, tax: 0 },
			{ description: "UI/UX Design & Wireframes", quantity: 1, unitPrice: 3000, discount: 0, tax: 0 },
			{ description: "Frontend Development", quantity: 1, unitPrice: 5000, discount: 0, tax: 0 },
			{ description: "Backend Development & API Integration", quantity: 1, unitPrice: 4000, discount: 0, tax: 0 },
			{ description: "Testing & QA", quantity: 1, unitPrice: 1500, discount: 0, tax: 0 },
			{ description: "Deployment & Launch Support", quantity: 1, unitPrice: 1000, discount: 0, tax: 0 },
		],
		defaultTerms: [
			"Payment is due within 30 days of invoice date.",
			"A 50% deposit is required before work commences.",
			"Scope changes require written approval and may affect pricing.",
			"This quote is valid for 30 days from the date of issue.",
		],
		defaultNotes: "Timeline: 8–12 weeks from project kickoff. Includes 2 rounds of design revisions.",
	},
	{
		id: "consulting",
		name: "Consulting Engagement",
		description: "Strategy, IT, or management consulting",
		icon: "Lightbulb",
		category: "consulting",
		accentColor: "#7c3aed",
		defaultItems: [
			{ description: "Initial Assessment & Audit", quantity: 8, unitPrice: 250, discount: 0, tax: 0 },
			{ description: "Strategy Development", quantity: 16, unitPrice: 250, discount: 0, tax: 0 },
			{ description: "Implementation Planning", quantity: 12, unitPrice: 250, discount: 0, tax: 0 },
			{ description: "Executive Presentation", quantity: 4, unitPrice: 250, discount: 0, tax: 0 },
		],
		defaultTerms: [
			"Engagement fees are billed monthly in arrears.",
			"Travel expenses are billed separately at cost.",
			"Confidentiality agreement included; NDA available upon request.",
			"A minimum engagement period of 3 months applies.",
		],
		defaultNotes: "Rates quoted are per hour. Weekly status reports included at no additional cost.",
	},
	{
		id: "brand-identity",
		name: "Brand Identity",
		description: "Logo, visual identity, and brand guidelines",
		icon: "Palette",
		category: "creative",
		accentColor: "#db2777",
		defaultItems: [
			{ description: "Brand Discovery Workshop", quantity: 1, unitPrice: 1200, discount: 0, tax: 0 },
			{ description: "Logo Design (3 concepts)", quantity: 1, unitPrice: 2500, discount: 0, tax: 0 },
			{ description: "Color Palette & Typography System", quantity: 1, unitPrice: 800, discount: 0, tax: 0 },
			{ description: "Brand Guidelines Document", quantity: 1, unitPrice: 1500, discount: 0, tax: 0 },
			{ description: "Business Card & Letterhead Design", quantity: 1, unitPrice: 600, discount: 0, tax: 0 },
		],
		defaultTerms: [
			"Up to 3 revision rounds are included in the quoted price.",
			"Additional revisions are billed at the hourly rate.",
			"Final files delivered in all standard formats (AI, PSD, PNG, SVG, PDF).",
			"Usage rights are transferred upon full payment.",
		],
		defaultNotes: "Timeline: 4–6 weeks. Mood board and initial concepts presented within 2 weeks.",
	},
	{
		id: "saas-product",
		name: "Software Product",
		description: "SaaS license, setup, and support packages",
		icon: "Package",
		category: "product",
		accentColor: "#059669",
		defaultItems: [
			{ description: "Annual Software License (Enterprise)", quantity: 1, unitPrice: 12000, discount: 10, tax: 0 },
			{ description: "Implementation & Setup", quantity: 1, unitPrice: 3000, discount: 0, tax: 0 },
			{ description: "Data Migration", quantity: 1, unitPrice: 2000, discount: 0, tax: 0 },
			{ description: "Training (on-site, 2 days)", quantity: 1, unitPrice: 2500, discount: 0, tax: 0 },
			{ description: "Premium Support (12 months)", quantity: 1, unitPrice: 3600, discount: 0, tax: 0 },
		],
		defaultTerms: [
			"Warranty period: 12 months from date of purchase.",
			"Shipping costs are calculated at checkout and added to the total.",
			"Returns accepted within 30 days of delivery in original packaging.",
			"Bulk orders (10+ units) qualify for volume discounts.",
		],
		defaultNotes: "License includes unlimited users. 99.9% uptime SLA included.",
	},
	{
		id: "freelance",
		name: "Freelance Project",
		description: "Flexible template for any freelance work",
		icon: "User",
		category: "service",
		accentColor: "#ea580c",
		defaultItems: [
			{ description: "Project scoping and planning", quantity: 2, unitPrice: 100, discount: 0, tax: 0 },
			{ description: "Core deliverable", quantity: 1, unitPrice: 2000, discount: 0, tax: 0 },
			{ description: "Revisions and refinement", quantity: 1, unitPrice: 500, discount: 0, tax: 0 },
		],
		defaultTerms: [
			"Payment is due within 30 days of invoice date.",
			"A 50% deposit is required before work commences.",
			"This quote is valid for 30 days from the date of issue.",
		],
		defaultNotes: "Flexible timeline — let's discuss what works best for your schedule.",
	},
	{
		id: "blank",
		name: "Blank Proposal",
		description: "Start from scratch with a clean slate",
		icon: "FileText",
		category: "custom",
		accentColor: "#475569",
		defaultItems: [],
		defaultTerms: ["This quote is valid for 30 days from the date of issue."],
		defaultNotes: "",
	},
];
